export const TEMPLATE = {
  UPLOAD:
    {
      PENDING: 'Pending',
      INPROGRESS: 'In Progress',
      COMPLETED: 'Completed',
      COMPLETEDWITHERRORS: 'Completed with errors',
      INVALIDUPLOAD: 'Invalid Upload',
      TEMPLATE: 'Template',
    },
  SPO_DATE_FORMAT: 'DD/MM/YYYY hh:mm a',
  ONBOARDING_PATH: '\\\\epicfileshare\\epicfiles$\\EPIC Archive\\PROD\\DocuSign\\CapitalLoanOnBoarding',
  ANNUALCONFIRMATION_PATH: '\\\\epicfileshare\\epicfiles$\\EPIC Archive\\PROD\\DocuSign\\CapitalLoanAmount',
}



// WEBPACK FOOTER //
// ./src/constants/templateupload.js